import theme from '@/src/config/theme'
import {css} from 'styled-components'

export const YaMapStyles = css`
  .ya-panel {
    background: black;
    padding: 10px;

    width: fit-content;
    min-height: 60px;

    .wrapper {
      position: relative;
    }

    &__content {
      display: flex;
      gap: 10px;
      align-items: center;
    }

    .arrow {
      position: relative;

      &:before {
        content: '';
        border: solid transparent;
        position: absolute;
        bottom: -19px;
        left: -19px;
        border-top-color: black;
        border-width: 9px;
        margin-right: -1px;
        transform: rotate(135deg);
      }
    }

    .close {
      transition: 0.3s ease all;
      width: 30px;
      height: 30px;
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      right: -15px;
      top: -15px;
      color: white;

      border-radius: 100%;

      &:hover {
        color: ${theme.colors.primary};
      }
    }
  }
`
